const getFriendlyMessage = (status, rawMessage) => {
  switch (status) {
    case 400:
      return rawMessage || 'Something went wrong with your request. Please try again.';
    case 401:
      return 'Your session has expired. Please log in again.';
    case 403:
      return "You don't have permission to do that.";
    case 404:
      return 'This could not be found.';
    case 429:
      return 'Too many requests. Please slow down and try again shortly.';
    case 500:
    case 502:
    case 503:
      return 'Something went wrong on our end. Please try again in a moment.';
    default:
      return rawMessage || 'Something went wrong. Please try again.';
  }
};


// Fetch notifications
export const fetchNotifications = async (apiCall, type = 'all', limit = 20, cursor = null) => {
  try {
    const params = new URLSearchParams({ 
      limit: limit.toString() 
    });
    if (type && type !== 'all') params.append('type', type);
    if (cursor) params.append('cursor', cursor);
    
    const response = await apiCall(`/api/notifications?${params.toString()}`);
    const data = await response.json();
    
    if (!response.ok) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('fetchNotifications error:', data.message || response.status);
      }
      throw new Error(getFriendlyMessage(response.status, data.message));
    }
    
    return {
      notifications: data.data.notifications || [],
      nextCursor: data.data.nextCursor || null,
      hasMore: data.data.hasMore || false
    };
  } catch (error) {
    throw error;
  }
};
// Get unread notification count
export const fetchUnreadCount = async (apiCall) => {
  try {
    const response = await apiCall('/api/notifications/unread-count');
    
    // ✅ Check if response is OK BEFORE parsing JSON
    if (!response.ok) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('fetchUnreadCount error:', response.status, response.statusText);
      }
      throw new Error(getFriendlyMessage(response.status));
    }
      
    const data = await response.json();
    
    return {
      unreadCount: data.data?.unreadCount || 0,
      pendingRequestsCount: data.data?.pendingRequestsCount || 0
    };
  } catch (error) {
    console.error("❌ fetchUnreadCount error:", error);
    throw error;
  }
};

// Mark all notifications as read
export const markAllNotificationsAsRead = async (apiCall) => {
  try {
    const response = await apiCall('/api/notifications/mark-all-read', {
      method: 'PUT'
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('markAllNotificationsAsRead error:', data.message || response.status);
      }
      throw new Error(getFriendlyMessage(response.status, data.message));
    }
    
    return {
      success: true,
      message: data.message
    };
  } catch (error) {
    throw error;
  }
};

// Respond to follow request
export const respondToFollowRequest = async (apiCall, notificationId, action) => {
  try {
    const response = await apiCall(`/api/notifications/${notificationId}/respond`, {
      method: 'PUT',
      body: JSON.stringify({ action })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('respondToFollowRequest error:', data.message || response.status);
      }
      throw new Error(getFriendlyMessage(response.status, data.message));
    }
      
    return {
      success: true,
      notification: data.data.notification,
      message: data.message
    };
  } catch (error) {
    throw error;
  }
};